import {Component} from "../../../gvf/js/component";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../js/utils-service";
import {ObjectService} from "../../js/object-service";

export class TaskRunButton extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    ready(){
        this.$root.click(
            (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                const taskName = $(ev.currentTarget).data("task");
                const taskParams = $(ev.currentTarget).data("task-params");
                GvfService.endpoint(
                    "/cp/task-detail/render-run-task-modal",
                    {taskName,taskParams}
                ).then(
                    (resp)=>{
                        const $modal = $(resp.html);
                        $("body").append($modal);
                        GvfUiService.init($modal);
                        $modal.modal("show");
                        $modal.find(".js-run-task-modal__confirm").click(
                            ()=>{
                                const $form = $modal.find(".js-form");
                                $form.checkRestrictions().then(
                                    (isOk)=>{
                                        if(isOk){
                                            const data = $modal.find(".js-form").getValues();
                                            if(taskParams && $.isPlainObject(taskParams)){
                                                for(let i in taskParams){
                                                    if(!data.hasOwnProperty(i)){
                                                        data[i] = taskParams[i];
                                                    }
                                                }
                                            }
                                            GvfService.endpoint(
                                                "/cp/task-detail/run-task",
                                                {taskName:taskName,formData:data}
                                            ).then(
                                                (resp)=>{
                                                    $modal.modal("hide");
                                                    const service = new ObjectService("TaskRun");
                                                    service.openDetailModal(
                                                        {
                                                            objectId: resp.task_run_id
                                                        }
                                                    );
                                                }
                                            ).catch(UtilsService.alertEndpointResponse);
                                        }
                                    }
                                );
                            }
                        );
                    }
                ).catch(UtilsService.alertEndpointResponse);
            }
        );
    }
}

